export default "__VITE_ASSET__$W9rKVSb__"